// extracted by mini-css-extract-plugin
export default {"messageContainer":"MessageContainer_messageContainer__Kl0rY","messageText":"MessageContainer_messageText__MVyRp"};